import { connect } from 'react-redux'
import { Dispatch } from 'redux'

import Component from '@cinch/oxd-components/auth-modal/src'
import { actions as authActions } from '@cinch/oxd-redux/auth/src'

export const mapStateToProps = (state: any) => ({
  isOpen: !!(state.auth && state.auth.showAuthModal),
})

export const mapDispatchToProps = (dispatch: Dispatch) => ({
  handleClose: () => dispatch(authActions.hideAuthModal()),
})

export default connect(mapStateToProps, mapDispatchToProps)(Component)
